module.exports = __webpack_public_path__ + "static/media/stay-safe-logo-charcoal.a210c49c.svg";